import React from 'react';
import styled from 'styled-components';

interface DownloadByUrl {
  url: string;
  getUrlOnClick?: never;
}

interface DownloadByGetter {
  getUrlOnClick: () => Promise<string>;
  url?: never;
}

type DownloadLinkProps = DownloadByUrl | DownloadByGetter;

const StyledLink = styled.a`
  color: inherit;
`;

export const DownloadOnClick: React.FC<DownloadLinkProps> = ({
  url,
  children,
  getUrlOnClick,
}) => {
  const onDownloadClick: React.MouseEventHandler<HTMLAnchorElement> = async (
    e,
  ) => {
    e.preventDefault();
    e.stopPropagation();

    const addAndRemoveLink = (urlToDownload) => {
      const ele = document.createElement('a');

      ele.setAttribute('href', urlToDownload);
      ele.setAttribute('download', 'saml.xml');
      document.body.appendChild(ele);
      ele.click();
      ele.remove();
    };

    if (url) {
      addAndRemoveLink(url);
    } else {
      getUrlOnClick?.().then(addAndRemoveLink);
    }
  };

  return <StyledLink onClick={onDownloadClick}> {children} </StyledLink>;
};
